module.exports = "/assets/data/9b4132199865f92bca43ac769351ac0d-EX23.data.json";